import fetchJSON from '../../fetchers/utils/fetchJSON.js';
import getFetchOptions from '../../fetchers/utils/getFetchOptions.js';
const options = /* #__PURE__*/getFetchOptions({
  circuitBreaker: {
    id: 'dealxg',
    fallback: {
      error: 'Circuit Breaker for /dealxg is open'
    },
    // This will avoid the circuit breaker to open,
    // useful when deal is just created trying to fetch deal details
    errorFilter: error => error?.status === 404
  },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-fwd-svc': 'atc'
  },
  credentials: 'omit',
  retryOn: [404],
  retryDelay: 250
});
function DealXgFetcher(path) {
  return {
    path: path + 'my-wallet/dealxg',
    async fetch() {
      let walletId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      try {
        const data = await fetchJSON(`${this.path}/deal?walletid=${walletId}`, options);
        if (data.error) {
          // eslint-disable-next-line no-console
          console.log('DealXgFetcher: ', data.error);
          return [];
        }
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('DealXgFetcher: ', error);
      }
      return [];
    },
    async resetDealNotifications(id, body) {
      if (body) {
        options.body = body;
      }
      try {
        const data = await fetchJSON(`${this.path}/id/${id}/status`, {
          ...options,
          method: 'PATCH'
        });
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('DealXgFetcher: ', error);
      }
      return {};
    }
  };
}
export { DealXgFetcher as default };
